import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext } from 'react';
import { useTheme } from 'styled-components';
import { StyledCard } from '../../../../common/base/Card';
import Text from '../../../../common/base/Text';
import { StyledRadioCard } from '../../../../common/Form/Fields/RadioCardsInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { useToasts } from '../../../../common/Toast';
import Modal from '../../../../common/Modal';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { APITeam, ProjectTypeInput } from '../../../../../../../../typings/Team.interface';
const DEFAULT_EVENT_GATEWAY_PROJECT_NAME = 'Event Gateway Starter';
const DEFAULT_OUTPOST_PROJECT_NAME = 'Outpost Starter';
const NewOrganizationModal: React.FC<{
  onClose: () => void;
  onSuccess: (team: APITeam) => void;
}> = t0 => {
  const $ = _c(12);
  const {
    onClose,
    onSuccess
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const theme = useTheme();
  let t1;
  if ($[0] !== HookdeckAPI.organizations || $[1] !== addToast || $[2] !== onSuccess) {
    t1 = v => {
      const project_name = v.type === "outpost" ? DEFAULT_OUTPOST_PROJECT_NAME : DEFAULT_EVENT_GATEWAY_PROJECT_NAME;
      HookdeckAPI.organizations.create({
        name: v.name,
        type: v.type,
        project_name
      }).then(t2 => {
        const {
          default_team
        } = t2;
        addToast("success", `Organization ${v.name} created`);
        onSuccess(default_team);
      }).catch(() => {
        addToast("error", "Failed to create the organization, please contact us.");
      });
    };
    $[0] = HookdeckAPI.organizations;
    $[1] = addToast;
    $[2] = onSuccess;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSubmit = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "",
      type: "event_gateway" as ProjectTypeInput
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onClose || $[6] !== theme.colors.surface.base.surface || $[7] !== theme.mode) {
    t3 = props => <form onSubmit={props.handleSubmit}><Modal portal={true} title="Create new organization" size="large" cancel_label="Cancel" hide_close={true} submit_label="Create organization" submit_icon={props.isSubmitting ? "loading" : "add_circle"} submit_disabled={props.isSubmitting || !props.dirty || !props.isValid} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose}><TextInput name="name" label="Organization name" required={true} focus={true} m={{
          b: 4
        }} /><Div m={{
          b: 2
        }}><Text semi={true} size="xs" muted={true} m={{
            b: 2
          }}>Initial project type</Text><Div grid={{
            columns: 2,
            gap: 2
          }} role="radiogroup"><StyledRadioCard as="label" checked={props.values.type === "event_gateway"} style={{
              backgroundColor: theme.colors.surface.base.surface
            }} flex={{
              direction: "column"
            }}><Div flex={{
                align: "flex-start",
                gap: 3
              }} p={4}><input style={{
                  marginTop: "1px"
                }} type="radio" name="type" value="event_gateway" checked={props.values.type === "event_gateway"} onChange={() => props.setFieldValue("type", "event_gateway")} /><Div flex={{
                  direction: "column",
                  gap: 1,
                  grow: true
                }}><Text semi={true}>Event Gateway</Text><Text muted={true} size="m" align="left">Handle events from external providers before they hit your application.</Text></Div></Div><Div flex={true} p={{
                x: 2,
                b: 2
              }}><StyledCard overflow_hidden={true} flex={{
                  align: "center",
                  justify: "center"
                }}><img src={`/images/usecase-receive-${theme.mode}.png`} alt="Event Gateway" style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                  }} /></StyledCard></Div></StyledRadioCard><StyledRadioCard as="label" checked={props.values.type === "outpost"} style={{
              backgroundColor: theme.colors.surface.base.surface
            }} flex={{
              direction: "column"
            }}><Div flex={{
                align: "flex-start",
                gap: 3
              }} p={4}><input style={{
                  marginTop: "1px"
                }} type="radio" name="type" value="outpost" checked={props.values.type === "outpost"} onChange={() => props.setFieldValue("type", "outpost")} /><Div flex={{
                  direction: "column",
                  gap: 1,
                  grow: true
                }}><Text semi={true}>Outpost</Text><Text muted={true} size="m" align="left">Deliver outbound webhooks and events from your API, SaaS, or PaaS.</Text></Div></Div><Div flex={true} p={{
                x: 2,
                b: 2
              }}><StyledCard overflow_hidden={true} flex={{
                  align: "center",
                  justify: "center"
                }}><img src={`/images/usecase-send-${theme.mode}.png`} alt="Outpost" style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain"
                  }} /></StyledCard></Div></StyledRadioCard></Div></Div></Modal></form>;
    $[5] = onClose;
    $[6] = theme.colors.surface.base.surface;
    $[7] = theme.mode;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onSubmit || $[10] !== t3) {
    t4 = <Formik initialValues={t2} validate={_temp} onSubmit={onSubmit}>{t3}</Formik>;
    $[9] = onSubmit;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default NewOrganizationModal;
function _temp(v_0) {
  if (!v_0.name || v_0.name.length === 0) {
    return {
      name: "Required"
    };
  }
  if (v_0.name && v_0.name.length > 40) {
    return {
      name: "Name is longer then 40 characters"
    };
  }
}